module.exports = __webpack_public_path__ + "img/done.116b36b8.svg";